import { FC } from 'react';
import { TaskCenterTypes } from '@frontend/api-task-center';
import { Icon } from '@frontend/icons';
import { type SelectedFilters } from '@frontend/task-center-scope';
import { callIntelIconStyle, aiAssistantStyles } from './task-item.styles';

interface TaskAIIconProps {
  source: TaskCenterTypes.TaskSource;
  creator?: SelectedFilters['creator'];
  isAIRCreatorEnabled: boolean;
}

export const TaskAIIcon: FC<TaskAIIconProps> = ({ source, creator, isAIRCreatorEnabled }) => {
  if (isAIRCreatorEnabled && creator && 'air' in creator) {
    return (
      <span css={aiAssistantStyles}>
        <Icon name='aiweave-assistant' size={12} />
      </span>
    );
  } else if (source === TaskCenterTypes.TaskSource.SOURCE_CALL_INTELLIGENCE) {
    return <Icon name='aiassistant-small' css={callIntelIconStyle} />;
  }
  return null;
};
